exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-msg[data-v-d38983b6]{z-index:9999}", ""]);

// exports
